<template>
    <div class="index notranslate">
        <v-header :is-seft="0"></v-header>

        <!-- cart content -->
        <mu-container class="content" v-show="!showOrderTip">
            <!-- Owner filter chips -->
            <div class="ower-filter">
                <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">
                    <mu-icon value="people" size="16"></mu-icon>
                    <span>{{$t('orderList.all')}}</span>
                </span>
                <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" v-for="(val, key, index) in cartOwerData" :key="index">
                    <mu-icon value="person" size="14"></mu-icon>
                    <span>{{key.replace(/\"/g,"")}}</span>
                </span>
            </div>

            <!-- Cart items grouped by category -->
            <div class="cart-box" v-for="(val, key, index) in cartShowData" :key="index">
                <div class="category-header">
                    <!-- <mu-icon value="restaurant" size="18"></mu-icon> -->
                    <span class="category-title">{{key.replace(/\"/g,"")}}</span>
                    <span class="category-count">{{val.length}}</span>
                </div>
                <div class="food-list">
                    <div class="food-item" v-for="item,index in val" :key="index">
                        <img class="food-img" :src="getImgUrl(item.foodImage,100)"/>
                        <div class="food-info">
                            <div class="food-name">{{item.foodName}}</div>
                            <div class="food-decide" v-if="item.decideName!=null && item.decideName!=''">
                                <mu-icon value="restaurant_menu" size="12"></mu-icon>
                                {{item.decideName}}
                            </div>
                            <div class="food-price">
                                <span class="now">{{Number(item.quantity * item.price).toFixed(0)}} {{seller.unit}}</span>
                                <span class="old" v-show="item.foodDiscount!=1">{{Number(item.quantity * item.price)}} {{seller.unit}}</span>
                            </div>
                        </div>
                        <div class="cart-opration notranslate">
                           
                            <span class="qty-num">X {{item.quantity}}</span>
                             <span class="qty-btn" :class="item.quantity <= 1 ? 'qty-delete' : 'qty-minus'" @click="cartOpration(item,'reduce')">
                                <mu-icon :value="item.quantity <= 1 ? 'delete' : 'remove'" size="16"></mu-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Total -->
            <div class="total-row">
                <span class="total-label">{{$t('orderList.total')}}</span>
                <span class="total-value">{{allAmount}} {{seller.unit}}</span>
            </div>

            <!-- Remark + taste -->
            <div class="remark-section">
                <div class="section-title">
                    <mu-icon value="edit" size="16"></mu-icon>
                    <span>{{ getSendKitchen() }}</span>
                </div>
                <div class="remark-box">
                    <textarea rows="3" v-model="tableOrderInfo.specielle" class="remark-input"></textarea>
                </div>
                <div class="taste-chips" v-if="tasteList.length>0">
                    <span class="taste-chip" @click="clickTaste(item)" v-for="(item,index) in tasteList" :key="index">{{item.tasteName}}</span>
                </div>
            </div>

            <div style="right:0;position:absolute;bottom:120px;" v-if="unPayTip!=''">
                <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{unPayTip}}</mu-chip>
            </div>

            <div class="cart-footer" v-show="disFlag">
                <div class="cart-footer-btn">
                    <div class="cart-footer-back" @click="jumpBack">
                        <mu-icon value="arrow_back" size="18"></mu-icon>
                        <span>{{$t('common.back')}}</span>
                    </div>
                </div>
                <div class="cart-footer-btn">
                    <div class="cart-footer-submit" @click="order">
                        <mu-icon value="check" size="18"></mu-icon>
                        <span>{{$t('common.submit')}}</span>
                    </div>
                </div>
            </div>

            <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="openFullscreen">
                <mu-appbar color="primary" title="Edit info">
                    <mu-button slot="left" icon @click="closeFullscreenDialog">
                        <mu-icon value="close"></mu-icon>
                    </mu-button>
                    <mu-button slot="right" flat @click="closeFullscreenDialog">
                        {{$t('common.save')}}
                    </mu-button>
                </mu-appbar>
                <div style="padding: 24px;">
                    <mu-form class="mu-demo-form" label-width="100">
                        <mu-form-item prop="tableOrderInfo.name" label="Name">
                            <mu-text-field v-model="tableOrderInfo.name"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.telephone" label="Telephone">
                            <mu-text-field v-model="tableOrderInfo.telephone"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.child" label="Voksne">
                            <mu-text-field v-model="tableOrderInfo.child"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.specielle" label="Specielle">
                            <mu-text-field multi-line :rows="3" :rows-max="6" v-model="tableOrderInfo.specielle"></mu-text-field>
                        </mu-form-item>
                    </mu-form>
                </div>
            </mu-dialog>

            <div class="loading-mask" v-if="isLoading">
                <div class="loading-spinner"></div>
                <div class="loading-text">{{$t('orderList.orderSubmitted')}}</div>
            </div>
        </mu-container>

        <div class="empty-page" v-show="showOrderTip">
            <div class="empty-icon">🍽️</div>
            <div class="empty-title">{{$t('orderList.submitCart')}}</div>
            <mu-button color="success" class="notranslate" @click="jumpBack" style="text-transform:unset;margin-top:20px;">
                {{$t('orderList.return')}}
            </mu-button>
        </div>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange" :overlay-close="false" :esc-press-close="false">
            {{$t('common.orderstatechange')}}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;"> {{$t('common.sure')}}</mu-button>
        </mu-dialog>
    </div>
</template>
<script>
    import header from '../components/Header';
    export default {
        name: 'Cart',
        data() {
            return {
                docked: false,
                open: false,
                tableOrderInfo: {},
                refreshDisbale: false,
                cartList: [],
                cartShowData: {},
                cartOwerData: {},
                openFullscreen: false,
                allAmount: 0,
                showOrderTip: false,
                packageType: 0,
                isSeft: 0,
                seller: {},
                isSeftPay: 0,
                current: -1,
                isLoading: false,
                tasteList: [],
                disFlag: true,
                chkPromise: true,
                configsData: {},
                orderData: {},
                orderList: [],
                unPayTip: '',
                openOrderChange: false,
                timer: null,
                singleOrderId: null
            }
        },
        computed: {
            payClass() {
                if (this.orderData != null) {
                    var person = this.orderData.adult;
                    if (this.orderData.child != null) {
                        person = person + parseInt(this.orderData.child);
                    }
                    var everybodyCopies = 20;
                    if (this.configsData.EverybodyCopies != null) {
                        everybodyCopies = parseInt(this.configsData.EverybodyCopies.toString());

                        var curEverybodyCopies = 0;
                        var curEverybodySeveral = 0;
                        var chkEverybodyCopies = false;
                        this.cartList.forEach((item) => {
                            curEverybodyCopies = item.quantity;
                            curEverybodySeveral+= (item.several * item.quantity);
                            this.orderList.forEach((rowData) => {
                                if (rowData.foodId == item.foodId) {
                                    curEverybodyCopies += rowData.quantity;
                                }
                            });
                            if (item.PerMaxCopies > 0 && item.PerMaxCopies <= curEverybodyCopies) {
                                this.unPayTip = item.foodName + this.$t("orderList.timeLimit", { num: item.perMaxCopies});
                                item.unAdd = true;
                                chkEverybodyCopies = true;
                            }
                            else {
                                item.unAdd = false;
                            }
                        })

                        if (curEverybodySeveral >= (everybodyCopies * person)) {
                            this.unPayTip = this.$t("orderList.timeLimit", { num: (everybodyCopies * person) });
                            return true;
                        }

                        if (chkEverybodyCopies) {
                            return false;
                        }
                    }
                }
                this.unPayTip = '';
                return false;
            }
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = this.$route.query.isSeft;
            this.packageType = this.$route.query.packageType;
            this.isSeftPay = this.$route.query.isSeftPay;
            this.getCartList();
            this.getFoodTasteList();
            this.getConfigs();
            this.getOrderList();
            // 先清再设，防止路由重复进入时 timer 叠加
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(() => {
                this.checkOrder()
            }, 60000);
        },
        methods: {
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            checkOrder() {
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                // 单点模式：首次进入没有订单属于正常情况，校验逻辑走单独分支
                if (this.configsData.SingleService != null && String(this.configsData.SingleService) === '1') {
                    this.checkOrderSingle(param);
                    return;
                }
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code==200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                clearInterval(this.timer);
                                this.timer = null;
                                this.openOrderChange = true;
                            }
                        }
                    });
            },
            // 单点模式订单校验：未记录订单时查未支付订单，空属正常不提示，首次拿到数据记录 orderId；
            // 已记录订单后用 CheckOrderState 校验订单是否仍存在，不存在说明订单状态已修改，弹出提示
            checkOrderSingle(param) {
                if (this.singleOrderId != null) {
                    this.$get('QRCodeOrder/CheckOrderState', { orderId: this.singleOrderId })
                        .then(response => {
                            if (response.code == 200) {
                                var stateData = response.data;
                                if (stateData == null || stateData == '') {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.singleOrderId = null;
                                    this.openOrderChange = true;
                                }
                            }
                        });
                    return;
                }
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                return;
                            }
                            this.singleOrderId = data.orderId;
                        }
                    });
            },
            removeTip(index) {
                this.unPayTip = "";
            },
            getSendKitchen() {
                return this.$t('orderList.sendKitchen');
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
            clickTaste(item) {
                if (this.tableOrderInfo.specielle == null || this.tableOrderInfo.specielle === '') {
                    this.tableOrderInfo.specielle = item.tasteName;
                } else {
                    this.tableOrderInfo.specielle = this.tableOrderInfo.specielle + ";" + item.tasteName;
                }
            },
            getOrderList() {
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                return;
                            }
                            this.orderData = data;
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.orderId })
                                .then(result => {
                                    if (result.code == 200) {
                                        this.orderList = result.data;
                                    }
                                });
                        }
                    });
            },
            getConfigs() {
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getFoodTasteList() {
                this.$get('QRCodeOrder/GetFoodTasteList', { RestaurantId: this.tableOrderInfo.restaurantId,})
                    .then(response => {
                        if (response.code==200) {
                            this.tasteList = response.data;
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getCartList() {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName
                };
                // 注意：不要在请求前先清空 allAmount，轮询时会导致价格从实际值跳到 0 再跳回来
                this.$get('QRCodeOrder/GetCartList', param)
                    .then(response => {
                        if (response.code==200) {
                            this.cartList = response.data;
                            this.current = -1;
                            if (this.cartList.length == 0) {
                                this.cartShowData = [];
                                this.allAmount = 0; // 只有购物车确认为空时才置 0
                                this.clear();
                                  this.$alert(this.$t("orderList.submittedTips"), this.$t("common.alert"), {
                                                type: 'info',
                                                okLabel: this.$t("common.ok"),
                                            });
                            }
                            else {
                                var total = 0;
                                this.showOrderTip = false;
                                this.cartList.forEach(function (item) {
                                    if (item.chargedOnce == 1) {
                                        total += item.price;
                                    }
                                    else {
                                        total += Math.round(item.quantity * item.price);
                                    }
                                });
                                this.allAmount = total;
                                this.cartOwerData = this.groupBy(this.cartList, (cart) => {
                                    return cart.createUser
                                });

                                this.cartShowData = this.groupBy(this.cartList, (cart) => {
                                    return cart.foodTypeName
                                });
                            }
                        } else {
                            this.clear();
                            this.showOrderTip = true;
                        }
                    });
            },
            selectOwerCartlist(index, val) {
                this.current = index;
                let list = [];
                if (val != null) {
                    list = val;
                }
                else {
                    list = this.cartList;
                }
                if (list.length > 0) {
                    var total = 0;
                    list.forEach(function (item) {
                        total += Math.round(item.quantity * item.price);
                    });
                    this.allAmount = total;

                    this.cartShowData = this.groupBy(list, (cart) => {
                        return cart.foodTypeName
                    });
                }
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getCartList();
                this.$toast.success('Successfully refresh!');
            },
            jumpBack() {
                this.clear();
                this.$router.go(-1);
            },
            jumpOrderLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/orderList', query: {
                        packageType: this.packageType,
                        isSeft: this.isSeft,
                        isBackMain: false,
                    }
                })
            },
            cartOpration(item, oprationType) {
                switch (oprationType) {
                    case 'add':
                        this.addToCart(item);
                        break;
                    case 'reduce':
                        if (item.quantity <= 0) {
                            return;
                        }
                        this.reduceCart(item);
                        break;
                }
            },
            addToCart(item) {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    FoodId: item.foodId,
                    FoodName: item.foodName,
                    ActDiscount: item.actDiscount,
                    Price: item.price,
                    FoodImage: item.foodImage,
                    FoodTypeName: item.foodTypeName,
                    AllowDiscounts: item.allowDiscounts,
                    Quantity: 1,
                    CreateUser: this.tableOrderInfo.name,
                    CreatePhone: this.tableOrderInfo.telephone,
                    IsSeft: this.isSeft,
                    Reamrk: item.reamrk,
                };
                this.$post('QRCodeOrder/AddtoCart', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.getCartList();
                        } else {
                            this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            reduceCart(item) {
                if (item.quantity <= 1) {
                    this.$confirm(this.$t("common.deleteConfirm"), this.$t("common.confirm"), {
                        type: 'warning',
                        okLabel: this.$t("common.ok"),
                        cancelLabel: this.$t("common.cancel")
                    }).then(({ result }) => {
                        if (result) {
                            let param = {
                                RestaurantId: this.tableOrderInfo.restaurantId,
                                TableName: this.tableOrderInfo.tableName,
                                FoodId: item.foodId,
                                FoodName: item.foodName,
                                ActDiscount: item.actDiscount,
                                Price: item.price,
                                FoodImage: item.foodImage,
                                FoodTypeName: item.foodTypeName,
                                AllowDiscounts: item.allowDiscounts,
                                Quantity: 1,
                                CreateUser: this.tableOrderInfo.name,
                                CreatePhone: this.tableOrderInfo.telephone,
                                IsSeft: this.isSeft,
                                Reamrk: item.reamrk,
                            };
                            this.$post('QRCodeOrder/ReduceCart', param)
                                .then(response => {
                                    if (response.code == 200) {
                                        this.getCartList();
                                    } else {
                                        this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                    }
                                });
                        } else {

                        }
                    });
                }
                else {
                    let param = {
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                        FoodId: item.foodId,
                        FoodName: item.foodName,
                        ActDiscount: item.actDiscount,
                        Price: item.price,
                        FoodImage: item.foodImage,
                        FoodTypeName: item.foodTypeName,
                        AllowDiscounts: item.allowDiscounts,
                        Quantity: 1,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: this.isSeft,
                        Reamrk: item.reamrk,
                    };
                    this.$post('QRCodeOrder/ReduceCart', param)
                        .then(response => {
                            if (response.code == 200) {
                                this.getCartList();
                            } else {
                                this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                            }
                        });
                }
            },
            openFullscreenDialog() {
                this.openFullscreen = true;
                this.open = false;
                this.docked = true;
            },
            closeFullscreenDialog() {
                this.openFullscreen = false;
            },
            dataRefreh() {
                if (this.intervalId != null) {
                    return;
                }
                this.intervalId = setInterval(() => {
                    this.getCartList();
                }, 10000);
            },
            clear() {
                clearInterval(this.intervalId);
                this.intervalId = null;
            },
            dataLen(d) {
                if (d < 10) {
                    return "0" + d;
                }
                return d;
            },
            order() {
                if (!this.timeOutCheck()) {
                    return;
                }
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                let chkParam = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.disFlag = false;
                // 单点模式没有套餐概念，无需校验 CheckIsBuffetPackage，直接下单
                if(this.isSeft==0 || (this.configsData.SingleService != null && String(this.configsData.SingleService) === '1')){
                    this.submitOrder();
                }
                else{
                this.$get('QRCodeOrder/CheckIsBuffetPackage', chkParam)
                    .then(response => {
                        if (response.code ==200) {
                            if (response.data) {
                                this.submitOrder();
                            }
                            else {
                                this.$router.push({
                                    path: '/buffetSelect', query: {
                                    }
                                })
                                this.$alert(this.$t("orderList.selectNumber"), this.$t("common.alert"), { type: 'info', okLabel: this.$t("common.ok") });
                            }
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert', { type: 'warning', okLabel: 'Sure' });
                        }
                    });
                }
            },
            submitOrder(){
                             let param = {
                                    RestaurantId: this.tableOrderInfo.restaurantId,
                                    TableName: this.tableOrderInfo.tableName
                                };
                                this.$get('QRCodeOrder/GetCartList', param)
                                    .then(result => {
                                        if (result.code==200) {
                                            this.cartList = result.data;
                                            this.showOrderTip = false;
                                                    this.isLoading = true;
                                                    var myDate = new Date();
                                                    var orderDate = myDate.getFullYear() + "-" + this.dataLen(myDate.getMonth() + 1) + "-" + this.dataLen(myDate.getDate()) + " " + this.dataLen(myDate.getHours()) + ":" + this.dataLen(myDate.getMinutes()) + ":00";
                                                     param = {
                                                        OrderType: 1,
                                                        RestaurantId: this.tableOrderInfo.restaurantId,
                                                        TableName: this.tableOrderInfo.tableName,
                                                        OrderFrom: 5,
                                                        OrderProcess:1,
                                                        DeliveryType: 1,
                                                        OrderDay: orderDate,
                                                        OrderAmount: 0,
                                                        OrderDiscount: 1,
                                                        ActualAmount: 0,
                                                        PostAmount: 0,
                                                        CouponAmount: 0,
                                                        Adult: this.tableOrderInfo.number,
                                                        State:1,
                                                        CustomerName: this.tableOrderInfo.name,
                                                        Telephone: this.tableOrderInfo.telephone,
                                                        Specielle: this.tableOrderInfo.specielle,
                                                        AccountId: 0,
                                                        PaymentType:0,
                                                        IsInvoice:0,
                                                        IsConformed:0,
                                                        OrderId: 0,
                                                        Rabatkode: '',
                                                        CreateUser:'user',
                                                        IsOrderBuffetPackage: 0,
                                                        IsSendSms:this.tableOrderInfo.isSendSms,
                                                        IsSeft:this.isSeft,
                                                    }
                                                    this.$post('QRCodeOrder/OrderQRCodeCartList', param)
                                                        .then(response => {
                                                            this.isLoading = false;
                                                            this.disFlag = true;
                                                            if (response != null) {
                                                                if (response.code == 200) {
                                                                    this.clear();
                                                                    this.$toast.success(this.$t("common.orderSuccess"));
                                                                    this.$router.push({
                                                                            path: '/orderList', query: {
                                                                                isSeft: this.isSeft,
                                                                                isSeftPay: this.isSeftPay
                                                                            }
                                                                        });
                                                                }
                                                                else {
                                                                    this.clear();
                                                                    if(response.msg.indexOf('&')>-1){
                                                                        var msgArr=response.msg.split('&');
                                                                        this.$alert(this.$t('orderList.foodMaxEachTimeOrder', { foodName:msgArr[0],num: msgArr[1] }) , this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                                                                    }
                                                                    else{
                                                                         this.$alert(this.$t(response.msg), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                                                                    }
                                                                }
                                                            } else {
                                                                this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                                            }
                                                        });
                                       
                                        } else {
                                            this.disFlag = true;
                                            this.clear();
                                            this.$alert(this.$t("orderList.submittedTips"), this.$t("common.alert"), {
                                                type: 'info',
                                                okLabel: this.$t("common.ok"),
                                            });
                                            this.showOrderTip = true;
                                        }
                                    });
            },
            timeOutCheck() {
                var time = window.localStorage.getItem('timeOut');
                let that = this;
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
        },
        created() {
            this.dataRefreh();

        },
        destroyed() {
            // 清理轮询定时器，组件销毁后不再发请求
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.clear();
        },
        activated() {
            this.getCartList();
        },
        components: {
            'v-header': header
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 0px;
    }

    .mu-button {
        text-transform: unset;
    }

    .material-icons {
        font-size: 12px;
    }

    .content {
        width: 100%;
        height: 100%;
        position: absolute;
        padding-bottom: 110px;
        padding-left: 0;
        padding-right: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        background: #f7f4f0;
    }

    /* ===== Owner filter chips ===== */
    .ower-filter {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 12px 14px;
        background: #fff;
        border-bottom: 1px solid #ece5db;
    }
    .ower-filter .material-icons {
        margin-right: 4px;
        vertical-align: middle;
    }

    .badge-num {
        display: inline-flex;
        align-items: center;
        padding: 6px 14px;
        font-size: 13px;
        font-weight: 500;
        background-color: #f0ebe3;
        color: #8a7e6e;
        border-radius: 18px;
        cursor: pointer;
        transition: all 0.2s;
        float: none;
        width: auto;
        height: auto;
        line-height: 1.4;
        margin: 0;
        overflow: visible;
    }
    .badge-num:active {
        transform: scale(0.95);
    }
    .badge-num.select {
        background: linear-gradient(135deg, #da5b3a, #e8856b);
        color: #fff;
        font-weight: 600;
        box-shadow: 0 2px 6px rgba(218,91,58,0.35);
    }

    /* ===== Cart box (per category) ===== */
    .cart-box {
        margin: 10px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(218,91,58,0.08);
    }

    .category-header {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 14px 10px 16px;
        font-size: 14px;
        font-weight: 600;
        color: #4a3b35;
        background: linear-gradient(135deg, #f5efe6 0%, #e8ddd0 100%);
        border-left: 3px solid #da5b3a;
        border-bottom: 1px solid #ece5db;
    }
    .category-header .material-icons {
        color: #da5b3a;
        font-size: 18px;
    }
    .category-title {
        flex: 1;
        color: #da5b3a;
    }
    .category-count {
        font-size: 12px;
        color: #8a7e6e;
        font-weight: 400;
        background: #f0ebe3;
        padding: 2px 8px;
        border-radius: 10px;
    }

    /* ===== Food item ===== */
    .food-list {
        padding: 0;
    }
    .food-item {
        display: flex;
        align-items: center;
        padding: 12px 14px;
        border-bottom: 1px solid #f2ece4;
        gap: 12px;
    }
    .food-item:last-child {
        border-bottom: none;
    }
    .food-img {
        width: 64px;
        height: 48px;
        border-radius: 6px;
        object-fit: cover;
        flex-shrink: 0;
        background: #f0ebe3;
    }
    .food-info {
        flex: 1;
        min-width: 0;
    }
    .food-name {
        font-size: 14px;
        font-weight: 600;
        color: #3d2e28;
        line-height: 1.3;
        margin-bottom: 4px;
    }
    .food-decide {
        display: flex;
        align-items: center;
        gap: 3px;
        font-size: 11px;
        color: #a08878;
        margin-bottom: 4px;
    }
    .food-decide .material-icons {
        font-size: 12px;
    }
    .food-price {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }
    .now {
        font-size: 15px;
        color: #f01414;
        font-weight: 700;
    }
    .old {
        font-size: 11px;
        text-decoration: line-through;
        color: #c8b0a0;
    }

    /* ===== Quantity control ===== */
    .cart-opration {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;
        margin-left: auto;
    }
    .qty-btn {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.15s;
        user-select: none;
    }
    .qty-btn .material-icons {
        font-size: 16px;
    }
    .qty-minus {
        background: #fff;
        border: 1.5px solid #ddd4c8;
        color: #a08878;
    }
    .qty-minus:active {
        background: #f0ebe3;
        border-color: #da5b3a;
    }
    .qty-delete {
        background: #fff;
        border: 1.5px solid #ddd4c8;
        color: #a08878;
    }
    .qty-delete:active {
        background: #ffebee;
        border-color: #ff5252;
    }
    .qty-btn.form-onlyread {
        background: #f0ebe3;
        border-color: #ece5db;
        color: #b89a88;
        pointer-events: none;
    }
    .qty-num {
        min-width: 24px;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        color: #3d2e28;
    }

    /* ===== Total row ===== */
    .total-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 12px 14px;
        padding: 14px 16px;
        background: linear-gradient(135deg, #fff5f2, #ffe8e0);
        border-radius: 10px;
    }
    .total-label {
        font-size: 18px;
        color: #3d2e28;
        font-weight: 700;
    }
    .total-value {
        font-size: 22px;
        font-weight: 700;
        color: #f01414;
    }

    /* ===== Remark section ===== */
    .remark-section {
        margin: 10px;
        padding: 14px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(218,91,58,0.08);
    }
    .section-title {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        font-weight: 600;
        color: #4a3b35;
        margin-bottom: 10px;
    }
    .section-title .material-icons {
        color: #da5b3a;
    }
    .remark-box {
        background: #fff;
        border-radius: 10px;
        border: 1.5px solid rgba(218, 91, 58, 0.35);
        box-shadow: 0 2px 8px rgba(218, 91, 58, 0.05);
        transition: border-color 0.2s, box-shadow 0.2s;
        overflow: hidden;
    }
    .remark-box:focus-within {
        border-color: #da5b3a;
        box-shadow: 0 0 0 3px rgba(218, 91, 58, 0.12);
    }
    .remark-box .remark-input {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border: none;
        outline: none;
        resize: none;
        padding: 8px 12px;
        font-size: 13px;
        line-height: 1.6;
        color: #3d2e28;
        background: transparent;
        font-family: inherit;
    }

    /* Taste chips */
    .taste-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 12px;
    }
    .taste-chip {
        display: inline-block;
        padding: 6px 14px;
        font-size: 12px;
        color: #8a7e6e;
        background: #f0ebe3;
        border-radius: 16px;
        cursor: pointer;
        transition: all 0.2s;
        border: 1px solid transparent;
        user-select: none;
    }
    .taste-chip:active {
        transform: scale(0.95);
        background: #da5b3a;
        color: #fff;
        border-color: #da5b3a;
    }

    /* ===== Bottom actions ===== */
    .cart-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        height: 54px;
        background: #fff;
        box-shadow: 0 -2px 12px rgba(218,91,58,0.1);
        z-index: 100;
    }
    .cart-footer-btn {
        flex: 1;
        height: 100%;
    }
    .cart-footer-btn .cart-footer-back,
    .cart-footer-btn .cart-footer-submit {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 14px;
        font-weight: 600;
        width: 100%;
        border-radius: 0;
    }
    .cart-footer-btn .cart-footer-back {
        background: #f7f4f0;
        color: #8a7e6e;
    }
    .cart-footer-btn .cart-footer-submit {
        background: linear-gradient(135deg, #4caf50, #4caf50);
        color: #fff;
        letter-spacing: 1px;
    }

    /* ===== Loading ===== */
    .loading-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.55);
        z-index: 99999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
    }
    .loading-spinner {
        width: 40px;
        height: 40px;
        border: 3px solid rgba(255,255,255,0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
        margin-bottom: 16px;
    }
    .loading-text {
        font-size: 15px;
    }
    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    /* ===== Empty page ===== */
    .empty-page {
        width: 100%;
        background: #fff;
        padding: 60px 20px;
        text-align: center;
    }
    .empty-icon {
        font-size: 60px;
        margin-bottom: 16px;
    }
    .empty-title {
        font-size: 16px;
        font-weight: 600;
        color: #da5b3a;
    }

    .form-onlyread {
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/CartList.vue